
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ServiceCRUD } from '../../../shared/crud/ServiceCRUD';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

@Injectable()
export class VendasPendentesService extends ServiceCRUD {
  private baseUrlService: string;
  public carregando = true;

  private valorRecebido = new BehaviorSubject<any>(null);
  valorModal$ = this.valorRecebido.asObservable();

  constructor(public httpClient: HttpClient, router: Router, protected toastr: ToastrService) {
    super(httpClient, router);
    this.baseUrlService = environment.URL_API;
  }

  protected getURL(): string {
    return `${this.baseUrlService}/vendasPendentesPecas`;
  }

  public getDados(
    data_inicial?: any,
    data_final?: any,
    dealers?: any,
    numeroOs?: any,
    chassi?: any,
    codItem?: any,
    original?: any
  ): Observable<any> {
    let params = new HttpParams();

    if (data_inicial) params = params.set('data_inicial', data_inicial.toString());
    if (data_final) params = params.set('data_final', data_final.toString());
    if (dealers) params = params.set('dealers', dealers.toString());
    if (numeroOs) params = params.set('numeroOs', numeroOs);
    if (chassi) params = params.set('chassi', chassi.toString());
    if (codItem) params = params.set('codItem', codItem.toString());
    if (original) params = params.set('original', original);


    return this.httpClient.get<any>(`${this.baseUrlService + '/vendasPendentesPecas'}`, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': JSON.parse(sessionStorage.getItem('currentUser')).token
      }),
      params: params
    });
  }

  atualizarModal(event: any) {
    this.valorRecebido.next(event)
  }

  receberValorModal() {
    return this.valorRecebido.getValue()
  }
}
